/** Service Desk console: Settings -> Connectors (SD-SC-17), part E: sync jobs and starter templates. */
export const serviceConnectorsE = {
  sync: {
    intro: "Mga naka-iskedyul na pagkuha ng isang nailathalang read operation papunta sa sariling mga talahanayan ng Sagot (produkto, asset, contact, organisasyon), itinutugma sa sariling id ng system.",
    add: "Magdagdag ng sync job",
    edit: "I-edit ang {{name}}",
    emptyTitle: "Walang sync job",
    emptyBody: "Live na kinukuwestyon ang {{name}} at walang iniimbak sa Sagot. Magdagdag ng naka-iskedyul na pagkuha kung kailangan mo ang data sa mga talahanayan ng Sagot.",
    lockTitle: "Kasama ang mga sync job mula sa Pro plan",
    lockBody: "Panatilihing napapanahon ang catalogue, mga asset, contact o organisasyon mula sa sarili mong system ayon sa iskedyul. I-upgrade para buksan ang mga sync job.",
    dialogHint: "Pumili ng nailathalang read operation na pinupunan ng mapping nito ang uri ng record na pipiliin mo.",
    tableLabel: "Mga sync job",
    name: "Pangalan ng job",
    nameRequired: "Bigyan ng pangalan ang job.",
    operation: "Operation",
    operationHint: "Mga nailathalang read operation lang ang maaaring i-sync.",
    noEligible: "Maglathala muna ng read operation.",
    operationRequired: "Pumili ng operation.",
    choose: "Pumili…",
    target: "Pinupunan ang",
    targetHint: "Mga uri ng record na available sa workspace mo.",
    targets: { products: "Mga produkto", assets: "Mga asset", contacts: "Mga contact", organisations: "Mga organisasyon" },
    schedule: "Iskedyul",
    schedules: { manual: "Mano-mano lang", hourly: "Bawat oras", nightly: "Gabi-gabi", custom: "Sariling iskedyul" },
    everyMinutes_one: "Bawat {{count}} minuto",
    everyMinutes_other: "Bawat {{count}} minuto",
    interval: "Minuto sa pagitan ng mga takbo",
    intervalInvalid: "Hindi bababa sa {{min}} minuto.",
    deletion: "Mga record na hindi na nakalista sa system",
    deletionHint: "Panatilihin, o i-archive sa Sagot.",
    deletions: { keep: "Panatilihin", archive: "I-archive" },
    incremental: "Kunin lang ang nagbago",
    incrementalHint: "Ipinapasa sa operation ang oras ng huling malinis na pagkuha.",
    param: "Parameter na tumatanggap ng oras",
    paramHint: "Parameter ng operation, tulad ng updated_since.",
    paramInvalid: "Gumamit ng maliliit na titik, numero at underscore.",
    format: "Format ng oras",
    formats: { iso: "ISO 8601", date: "Petsa lang", epoch: "Unix seconds" },
    enabled: "Naka-enable",
    enabledAria: "I-enable ang {{name}}",
    lastRun: "Huling takbo",
    nextRun: "Susunod na takbo",
    neverRun: "Hindi pa tumatakbo",
    status: { queued: "Nakapila", running: "Tumatakbo", succeeded: "Nagtagumpay", partial: "Bahagyang natapos", failed: "Nabigo" },
    runNow: "Patakbuhin ngayon",
    runNowAria: "Patakbuhin ngayon ang {{name}}",
    queued: "Nakapila ang {{name}}",
    runs: "Mga takbo",
    runsAria: "Mga takbo ng {{name}}",
    started: "Nagsimula",
    noRuns: "Wala pang takbo.",
    counts: { fetched: "Nakuha", created: "Nalikha", updated: "Na-update", unchanged: "Walang pagbabago", failed: "Nabigo" },
    saved: "Na-save ang sync job",
    deleteAria: "Burahin ang {{name}}",
    deleteTitle: "Burahin ang {{name}}?",
    deleteBody: "Aalisin ang iskedyul at ang kasaysayan ng mga takbo nito. Nananatili sa Sagot ang mga record na na-sync na.",
    deleteConfirm: "Burahin ang job",
  },
  templates: {
    crm: {
      name: "Paghahanap sa CRM",
      hint: "Hanapin ang contact sa e-mail o id sa CRM mo.",
      ops: {
        find_contact_by_email: { name: "Hanapin ang contact sa e-mail", ai: "Hinahanap ang contact sa CRM gamit ang e-mail address at ibinabalik ang id at pangalan nila." },
        get_contact: { name: "Kunin ang contact", ai: "Ibinabalik ang isang contact mula sa CRM gamit ang id." },
      },
    },
    orders: {
      name: "Order system",
      hint: "Katayuan ng order, tracking at pag-order.",
      ops: {
        get_order_status: { name: "Tingnan ang katayuan ng order", ai: "Tinitingnan ang katayuan at tracking ng isang order gamit ang numero nito. Ligtas tawagan." },
        list_orders: { name: "Ilista ang mga order ng customer", ai: "Inilalista ang mga order ng isang customer." },
        create_order: { name: "Lumikha ng order", ai: "Naglalagay ng order. Isang write: maipapanukala lang ito ng assistant; tatakbo pagkatapos kumpirmahin ng kliyente." },
      },
    },
    records: {
      name: "Paghahanap ng talaan ng estudyante o HR",
      hint: "Hanapin ang talaan ng estudyante, empleyado o miyembro sa numero o e-mail.",
      ops: {
        lookup_record: { name: "Hanapin ang talaan", ai: "Hinahanap ang isang talaan gamit ang numero nito at ibinabalik ang katayuan." },
        find_record_by_email: { name: "Hanapin ang talaan sa e-mail", ai: "Hinahanap ang numero ng talaan na kabilang sa isang e-mail address." },
      },
    },
    booking: {
      name: "Booking",
      hint: "Mga bakanteng slot, bagong booking at cancellation.",
      ops: {
        list_slots: { name: "Ilista ang bakanteng slot", ai: "Inilalista ang mga bakanteng oras para sa isang petsa at opsyonal na serbisyo." },
        create_booking: { name: "Lumikha ng booking", ai: "Nagbu-book ng slot. Isang write: kailangan ang kumpirmasyon ng kliyente." },
        cancel_booking: { name: "I-cancel ang booking", ai: "Kinakansela ang booking. Mapanira: staff o kumpirmadong kliyente lang." },
      },
    },
    billing: {
      name: "Katayuan ng billing",
      hint: "Katayuan ng invoice at mga invoice ng customer.",
      ops: {
        get_invoice_status: { name: "Kunin ang katayuan ng invoice", ai: "Ibinabalik ang katayuan at halagang dapat bayaran ng isang invoice." },
        list_invoices: { name: "Ilista ang mga invoice ng customer", ai: "Inilalista ang mga invoice ng isang customer." },
      },
    },
    tickets: {
      name: "Ticket tool",
      hint: "Magbasa o magbukas ng ticket sa ibang helpdesk.",
      ops: {
        get_ticket: { name: "Kunin ang ticket", ai: "Ibinabalik ang katayuan ng isang ticket sa kabilang tool." },
        create_ticket: { name: "Lumikha ng ticket", ai: "Nagbubukas ng ticket sa kabilang tool. Isang write: kailangan ng kumpirmasyon." },
      },
    },
    assets: {
      name: "Talaan ng kagamitan",
      hint: "Hanapin ang isang kagamitan gamit ang serial number nito.",
      ops: { lookup_serial: { name: "Hanapin ang kagamitan sa serial number", ai: "Hinahanap ang isang kagamitan gamit ang serial number at ibinabalik ang modelo, may-ari at petsa ng pagtatapos ng warranty. Ligtas tawagin." } },
    },
    custom: {
      name: "Custom API",
      hint: "Sarili mong internal API, nagsisimula sa health check.",
      ops: { ping: { name: "Health check", ai: "Sinusuri kung sumasagot ang system. Walang binabasang data." } },
    },
  },
};
